module.exports = __webpack_public_path__ + "assets/img/btn-view-info-hover-90ad1528.png";